<template>
    <div style="position: relative; z-index: 10;">
        <CommonPopupFrame :changeHeight="95" :isOpen="isOpenReviewWriteForm" :changeBottom="0" :closeCompleteAction="closeReviewWriteForm">
            <div style="height:20px;">
                <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
            </div>
            <div style="display:flex; justify-content: space-between; padding: 0 12px; padding-top:10px; position: relative; border-bottom: 1px solid #f5f5f5; padding-bottom: 8px;">
                <div style="width:80px; text-align:center; display: flex; align-items: center;" @click.stop="closeReviewWriteForm">
                    <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
                </div>
                <div style="position: absolute; left: 50%; transform: translateX(-50%); text-align: center;">
                    <div style="font-weight:bold; font-size:16px; color:#210F03">리뷰</div>
                    <div style="font-weight:bold; font-size:12px; color:#606060; margin-top:8px">{{ $Util.getYYYMMDDHangulStr(today) }}</div>
                </div>
                <div @click="submitReview" :style="{ color: contents.length === 0 ? '#d9d9d9' : '#210f03' }" style="font-weight: 700; margin-top: 4px;">리뷰 작성하기</div>
            </div>
            <div @touchmove.stop="() => { }" style="padding: 0 12px; flex: 1;">
                <div style="border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                    <textarea v-model="contents" maxlength="200" rows="1" ref="text_area" @input="test" placeholder="내용을 입력하세요" name="" id="" style="resize: none; border: none; line-height: 28px; margin-top: 20px; width: 100%; max-height: 300px; outline: none;"></textarea>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame';
import moment from "moment"
import ResponseCode from '@/ResponseCode';

export default {
    name: "TeamTrainingReviewWriteForm",
    components: {
        CommonPopupFrame
    },
    props: {
        isOpenReviewWriteForm: {
            type: Boolean,
            default: false
        },
        closeReviewWriteForm: {
            type: Function,
            default: () => { }
        },
        scheduleIdx: {
            type: [Number, String],
            default: -1
        },
        repeatScheduleIdx: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            contents: '',
            today: ''
        }
    },
    methods: {
        test() {
            this.$refs.text_area.style.height = 'auto'
            this.$refs.text_area.style.height = this.$refs.text_area.scrollHeight + 'px'
        },
        async submitReview() {
            if (this.contents.length === 0) {
                this.$GlobalStore.showAlert('내용을 작성해주세요')
                return
            }
            this.$GlobalStore.showProgress()
            const formData = new FormData();
            formData.append('parentIdx', this.scheduleIdx);
            formData.append('contents', this.contents);
            formData.append('type', 'schedule');
            formData.append('mode', 'insert');
            if (this.repeatScheduleIdx) formData.append('refer_idx', this.repeatScheduleIdx);

            const res = await this.$Axios.post('/api/soccerhow/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress();
                this.closeReviewWriteForm(true);
                this.contents = '';
                // if (this.isShowTeamTrainingDetailWhenSave) this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: this.scheduleIdx });
            } else if (res.data.msg === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
    },
    created() {
        this.today = moment().format("YYYY-MM-DD");
    }
}
</script>